import React, { useState } from 'react';
import './css/services.css';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faq-item">
      <div onClick={toggle} className="faq-question">
        <strong>{question}</strong>
        <span>{isOpen ? '▲' : '▼'}</span>
      </div>
      {isOpen && (
        <div className="faq-answer">
          {answer}
        </div>
      )}
    </div>
  );
};

const FAQList = () => {
  const faqs = [
     {
    question: 'What is SEO page content?',
    answer: 'SEO page content is optimized website copy that targets specific keywords to improve your site\'s visibility on search engines like Google.',
  },
  {
    question: 'Why is SEO content important for my website?',
    answer: 'It helps your website rank higher in search results, attract organic traffic, and convert visitors into leads or customers.',
  },
  {
    question: 'Do you include meta titles and descriptions with the content?',
    answer: 'Yes, we provide fully optimized content including title tags, meta descriptions, headers, and keyword placement.',
  },
  {
    question: 'How do you choose which keywords to target?',
    answer: 'We conduct keyword research based on your industry, audience, and competition to select high-impact, relevant terms.',
  },
  {
    question: 'Can you update existing pages with SEO content?',
    answer: 'Absolutely. We audit and rewrite existing pages to improve their performance without compromising your brand voice.',
  },
  {
    question: 'Do you follow Google’s latest algorithm updates?',
    answer: 'Yes, we stay updated with Google’s guidelines and continuously adjust our SEO writing practices accordingly.',
  },
    // Add more questions and answers as needed
  ];

  return (
    <div>
      {faqs.map((faq, index) => (
        <FAQItem key={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
  );
};

const App = () => {
  return (
    <div style={{ padding: '5%' }}>
      <div className="seo-main-faq">
    <div className="seo-main-heading">
      <h1>FAQ’S</h1>
    </div>
      <div className="seo-main-para">
        <p></p>
      </div>
      </div>
      <FAQList />
    </div>
  );
};

export default App;
